var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 2.00016C13.1585 2.00016 15.9752 3.77516 17.3502 6.5835C15.9752 9.39183 13.1585 11.1668 10.0002 11.1668C6.84183 11.1668 4.02516 9.39183 2.65016 6.5835C4.02516 3.77516 6.84183 2.00016 10.0002 2.00016ZM10.0002 0.333496C5.8335 0.333496 2.27516 2.92516 0.833496 6.5835C2.27516 10.2418 5.8335 12.8335 10.0002 12.8335C14.1668 12.8335 17.7252 10.2418 19.1668 6.5835C17.7252 2.92516 14.1668 0.333496 10.0002 0.333496ZM10.0002 4.50016C11.1502 4.50016 12.0835 5.4335 12.0835 6.5835C12.0835 7.7335 11.1502 8.66683 10.0002 8.66683C8.85016 8.66683 7.91683 7.7335 7.91683 6.5835C7.91683 5.4335 8.85016 4.50016 10.0002 4.50016ZM10.0002 2.8335C7.9335 2.8335 6.25016 4.51683 6.25016 6.5835C6.25016 8.65016 7.9335 10.3335 10.0002 10.3335C12.0668 10.3335 13.7502 8.65016 13.7502 6.5835C13.7502 4.51683 12.0668 2.8335 10.0002 2.8335Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionEyeIcon);
export default __webpack_public_path__ + "static/media/action_eye_icon.2527385cebc1c06c2ba662a87eef5761.svg";
export { ForwardRef as ReactComponent };